// src/components/Navbar.js
import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import './style.css';

export const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?query=${encodeURIComponent(searchQuery.trim())}`);
      setSearchQuery("");
    }
  };

  // Close dropdown when clicking outside
  React.useEffect(() => {
    const handleClick = (e) => {
      if (!e.target.closest('.nav-more')) setIsDropdownOpen(false);
    };
    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClick);
    }
    return () => document.removeEventListener('mousedown', handleClick);
  }, [isDropdownOpen]);

  return (
    <nav className="nav-header">
      <div className="nav-container">
        <div className="nav-row">
          <div className="nav-logo-and-links">
            <Link to="/" className="nav-logo-link">
              <span role="img" aria-label="clapperboard">
                🎬
              </span>
              <span className="nav-logo-text">Rant Hub</span>
              <span role="img" aria-label="popcorn">
                🍿
              </span>
            </Link>
            <div className="nav-links-desktop">
              <Link to="/" className="nav-link">
                Home
              </Link>
              <Link to="/my-reviews" className="nav-link">
                My Reviews
              </Link>
              <Link to="/about" className="nav-link">
                About
              </Link>
              <div className="nav-more" tabIndex={0}>
                <button
                  className="nav-link nav-more-btn"
                  onClick={() => setIsDropdownOpen((v) => !v)}
                  aria-haspopup="true"
                  aria-expanded={isDropdownOpen}
                  type="button"
                >
                  More ▼
                </button>
                {isDropdownOpen && (
                  <div className="nav-more-dropdown">
                    <Link to="/movies" className="nav-link" onClick={() => setIsDropdownOpen(false)}>
                      Movies
                    </Link>
                    <Link to="/tv-shows" className="nav-link" onClick={() => setIsDropdownOpen(false)}>
                      TV Shows
                    </Link>
                    <Link to="/games" className="nav-link" onClick={() => setIsDropdownOpen(false)}>
                      Games
                    </Link>
                    <Link to="/blog" className="nav-link" onClick={() => setIsDropdownOpen(false)}>
                      Blog
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="nav-search-desktop">
            <form onSubmit={handleSearch} className="navbar-search-form">
              <input
                type="text"
                placeholder="Search movies/TV..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="navbar-search-bar"
              />
              <button type="submit" className="navbar-search-button">
                Search
              </button>
            </form>
          </div>
          <button
            className="nav-menu-btn"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? "✖" : "☰"}
          </button>
        </div>
        {isMenuOpen && (
  <div className="nav-mobile-menu">
    <form
      className="nav-mobile-search"
      onSubmit={(e) => {
        e.preventDefault();
        if (searchQuery.trim()) {
          navigate(`/search?query=${encodeURIComponent(searchQuery.trim())}`);
          setSearchQuery("");
          setIsMenuOpen(false);
        }
      }}
    >
      <input
        type="text"
        placeholder="Search movies/TV..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="nav-search-input"
      />
      <button type="submit" className="nav-search-button-mobile">
        Search
      </button>
    </form>
    
    <Link
      to="/"
      className="nav-link-mobile"
      onClick={() => setIsMenuOpen(false)}
    >
      Home
    </Link>
    <Link
      to="/my-reviews"
      className="nav-link-mobile"
      onClick={() => setIsMenuOpen(false)}
    >
      My Reviews
    </Link>
    <Link
      to="/about"
      className="nav-link-mobile"
      onClick={() => setIsMenuOpen(false)}
    >
      About
    </Link>
    <div className="nav-link-mobile nav-more-mobile">
      <span>More</span>
      <div className="nav-more-dropdown-mobile">
        <Link to="/movies" className="nav-link-mobile" onClick={() => setIsMenuOpen(false)}>
          Movies
        </Link>
        <Link to="/tv-shows" className="nav-link-mobile" onClick={() => setIsMenuOpen(false)}>
          TV Shows
        </Link>
        <Link to="/games" className="nav-link-mobile" onClick={() => setIsMenuOpen(false)}>
          Games
        </Link>
      </div>
    </div>
  </div>
)}
      </div>
    </nav>
  );
};

export default Navigation;